import type { DrawerComponentProps } from '@/types/drawer';

import {
  AllInbox,
  AutoAwesomeMotion,
  AutoStories,
  Campaign,
  Extension,
  Forum,
  Groups,
  Mail,
  Settings,
  SpaceDashboard,
  Timeline,
  Workspaces,
} from '@mui/icons-material';
import PhoneForwardedIcon from '@mui/icons-material/PhoneForwarded';

export const mainDrawerComponents: DrawerComponentProps[] = [
  {
    name: 'Dashboard',
    id: 'dashboard',
    path: '/dashboard',
    icon: 'chart-line',
  },
  {
    name: 'Converse',
    id: 'converse',
    path: '/converse',
    icon: 'comments',
  },
  // {
  //   name: 'Prospector',
  //   id: 'prospector',
  //   path: '/prospector',
  //   icon: 'users-viewfinder',
  // },
  {
    name: 'Transcripts',
    id: 'communications',
    path: '/communications',
    icon: 'house',
  },
  {
    name: 'Leads',
    id: 'leads',
    path: '/leads',
    icon: 'users-viewfinder',
  },
  {
    name: 'Campaigns',
    id: 'campaigns',
    path: '/campaigns',
    icon: 'bullhorn',
  },
  {
    name: 'Calls',
    id: 'phone',
    path: '/calls-dashboard',
    icon: 'phone',
  },
  {
    name: 'Inbox',
    id: 'inbox',
    path: '/inbox',
    icon: 'inbox',
  },
  // {
  //   name: 'Email Queue',
  //   id: 'email_queue',
  //   path: '/email-queue',
  //   icon: 'envelopes-bulk',
  // },
  {
    name: 'Integrations',
    id: 'integrations',
    path: '/integrations',
    icon: 'plug-circle-plus',
  },
  {
    name: 'Context',
    id: 'context',
    path: '/context',
    icon: 'book-open',
  },
  {
    name: 'Traces',
    id: 'traces',
    path: '/traces',
    icon: 'timeline',
  },
  {
    name: 'Settings',
    id: 'settings',
    path: '/settings',
    icon: 'gear',
  },
  // {
  //   name: 'Workspace',
  //   id: 'workspace',
  //   path: '/workx',
  //   icon: 'workspace',
  // },
];

export const iconSvgs: Record<
  (typeof mainDrawerComponents)[0]['id'],
  React.ReactElement
> = {
  dashboard: <SpaceDashboard />,
  converse: <Forum />,
  communications: <AutoAwesomeMotion />,
  leads: <Groups />,
  campaigns: <Campaign />,
  phone: <PhoneForwardedIcon />,
  inbox: <AllInbox />,
  email_queue: <Mail />,
  integrations: <Extension />,
  context: <AutoStories />,
  traces: <Timeline />,
  settings: <Settings />,
  workspaces: <Workspaces />,
};

export const settingsDrawerComponents: DrawerComponentProps[] = [
  {
    name: 'API Keys',
    id: 'api-keys',
    path: '/settings/api-keys',
  },
  {
    name: 'Billing',
    id: 'billing',
    path: '/settings/billing',
  },
  {
    name: 'Usage',
    id: 'usage',
    path: '/settings/usage',
  },
];

export const integrationsDrawerComponents: DrawerComponentProps[] = [
  {
    name: 'My integrations',
    id: 'my-integrations',
    path: '/integrations',
  },
  {
    name: 'Slack',
    id: 'slack',
    path: '/integrations/slack',
  },
  {
    name: 'Discord',
    id: 'discord',
    path: '/integrations/discord',
  },
  {
    name: 'Telegram',
    id: 'telegram',
    path: '/integrations/telegram',
  },
  {
    name: 'Google Workspace',
    id: 'ms-teams',
    path: '/integrations/google-workspace',
  },
];

export const navbarComponents: DrawerComponentProps[] = [
  {
    name: 'Dashboard',
    id: 'dashboard',
    path: '/dashboard',
  },
  {
    name: 'Integrations',
    id: 'integrations',
    path: '/integrations',
  },
  {
    name: 'Docs',
    id: 'docs',
    path: '/docs',
  },
];
